import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatStepper } from '@angular/material';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import { TestCallAgentComponent } from './test-call-agent/test-call-agent.component';

@Component({
  selector: 'hour4u-admin-create-agent',
  templateUrl: './create-agent.component.html',
  styleUrls: ['./create-agent.component.scss']
})
export class CreateAgentComponent implements OnInit {
  @ViewChild('stepper', { static: true }) stepper: MatStepper;

  agentFirstForm: FormGroup;
  agentSecondForm: FormGroup;
  agentThirdForm: FormGroup;
  agentTypesList: any[] = ['Outbound', 'Inbound'];
  isUploading: boolean = false;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  callActions: any[] = [
    {
      id: 1,
      value: 'Send email'
    },
    {
      id: 2,
      value: 'Schedule appointment'
    },
    {
      id: 3,
      value: 'Transfer call'
    },
    {
      id: 4,
      value: 'Send SMS'
    },
    {
      id: 5,
      value: 'Take message and send email'
    },
  ];
  appearanceList: any[] = [
    {
      id: 1,
      value: 'red',
      label: 'Red'
    },
    {
      id: 2,
      value: 'yellow',
      label: 'Yellow'
    },
    {
      id: 3,
      value: 'blue',
      label: 'Blue'
    },
    {
      id: 4,
      value: 'pink',
      label: 'Pink'
    },
  ];
  times = this.generateTimeSlots();
  timeDifferences: { [key: string]: string } = {};
  timeFrom: any;
  scripts: any;
  isLoading: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private employerUploadService: EmployerUploadService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.openTestCallAgentPopup();
    this.agentFirstForm = this._fb.group({
      agent_id: [''],
      agent_type: ['', [Validators.required]],
      agent_name: ['', [Validators.required]],
      about_agent: [''],
      agent_goal: ['']
    })

    this.agentSecondForm = this._fb.group({
      company_name: ['', [Validators.required]],
      company_info: [''],
      faqs_answer: [''],
      additional_info: [''],
      additional_infos: this._fb.array([]),
      script: [''],
      scripts: this._fb.array([])
    })

    this.agentThirdForm = this._fb.group({
      outcomes: this._fb.array([this.getOutComesArray()]),
    })
    console.log(this.agentFirstForm)
  }

  // attachments Form init
  attachmentsForm(attachment: any = {}): FormGroup {
    return this._fb.group({
      name: [attachment.name || ''],
      value: [attachment.value || ''],
    });
  }

  get additional_infos(): FormArray {
    return this.agentSecondForm.get('additional_infos') as FormArray;
  }

  getOutComesArray() {
    let f = this._fb.group({
      outcome_name: ['', [Validators.required]],
      outcome_appearance: ['', [Validators.required]],
      outcome_description: [''],
      conditions: this._fb.array([this.getConditionsArray()]),
      callActions: this._fb.array([this.getActionsArray()]),
    });
    return f;
  }

  getConditionsArray() {
    let f = this._fb.group({
      condition: ['', [Validators.required]],
    });
    return f;
  }

  getActionsArray() {
    let f = this._fb.group({
      call_action: ['', [Validators.required]],
      email_subject: [''],
      email_content: [''],
      when_to_trigger: [''],
      add_link_to_calendar: [''],
      days: this._fb.array(this.getDaysArray()), // Days as FormArray
      slots: this._fb.array([]), // Slots as FormArray  
      appointment_time: [''],
      allow_booking_on_same_day_as_call: [''],
      receive_booking_appointment_notifications_via_email: [''],
      phone_number: [''],
      sms_content: [''],
      emails_list: ['']
    });
    return f;
  }

  // Generate array for days
  getDaysArray() {
    return [
      this.createDayControl('Monday'),
      this.createDayControl('Tuesday'),
      this.createDayControl('Wednesday'),
      this.createDayControl('Thursday'),
      this.createDayControl('Friday'),
      this.createDayControl('Saturday'),
      this.createDayControl('Sunday'),
    ];
  }

  // Create a single day control
  createDayControl(dayName: string) {
    return this._fb.group({
      day: [dayName],
      isSelected: [false],
      startTime: ['08:00 AM'],
      endTime: ['06:00 PM'],
    });
  }

  // // Generate 15-minute slots
  // generateTimeSlots(start: string, end: string) {
  //   let slots = [];
  //   let startTime = this.convertToMinutes(start);
  //   let endTime = this.convertToMinutes(end);
  //   for (let time = startTime; time < endTime; time += 15) {
  //     slots.push(this.convertToTimeFormat(time));
  //   }
  //   return slots;
  // }

  // Helper function to convert time string to minutes
  convertToMinutes(time: string): number {
    let [hours, minutes] = time.split(/[: ]/).map(Number);
    if (time.includes('PM') && hours !== 12) hours += 12;
    if (time.includes('AM') && hours === 12) hours = 0;
    return hours * 60 + minutes;
  }

  // Helper function to convert minutes to time string
  convertToTimeFormat(minutes: number): string {
    let hours = Math.floor(minutes / 60);
    let mins = minutes % 60;
    let period = hours >= 12 ? 'PM' : 'AM';
    if (hours > 12) hours -= 12;
    if (hours === 0) hours = 12;
    return `${this.pad(hours)}:${this.pad(mins)} ${period}`;
  }

  // Pad single digit numbers with a leading zero
  pad(num: number): string {
    return num.toString().padStart(2, '0');
  }

  selectedAgentType(agentType) {
    console.log(agentType)
  }

  // on file select for attachments upload
  onFileSelected(event: Event, field?: any) {
    console.log(field)
    if (field) {
      field.isLoading = true;
      // field.value = [];
      // field.fileName = [];
    } else {
      this.isUploading = true;
    }
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      const additional_infos = this.agentSecondForm.get('additional_infos') as FormArray;
      // const attachments = this.projectFormGroup.get('attachments') as FormArray;

      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];

        // Upload the file to S3 using the existing function
        this.employerUploadService.uploadProfileImage(file).subscribe(
          (s3File) => {
            console.log('File uploaded successfully:', s3File);
            if (field) {
              field.value.push(s3File.key);
              field.fileName.push(file.name);
            } else {
              let obj = {
                name: file.name,
                value: s3File.key
              }
              additional_infos.push(this.attachmentsForm(obj));
              // attachments.push(this.attachmentForm(s3File.key));
              // this.selectedFileNames.push(file.name);
            }
            if (inputElement.files.length - 1 == i) {
              if (field) {
                field.isLoading = false;
              } else {
                this.isUploading = false;
              }
              // console.log(this.customFieldsArray)
              console.log(additional_infos)
            }
          },
          (error) => {
            if (field) {
              field.isLoading = false;
            } else {
              this.isUploading = false;
            }
            console.error('Error uploading file:', error);
          }
        );
      }
    }
  }

  // delete Selected File
  deleteSelectedFile(index, fields?: any) {
    console.log(index, fields)
    if (fields) {
      fields.splice(index, 1);
    } else {
      const additional_infos = this.agentSecondForm.get('additional_infos') as FormArray;
      additional_infos.removeAt(index);
    }
  }

  // get CTA Label
  getCTALabel() {
    let label = 'Next';
    if (this.stepper.selectedIndex == 0) {
      label = "Next";
    }
    if (this.stepper.selectedIndex == 1) {
      label = "Next";
    }
    if (this.stepper.selectedIndex == 2) {
      label = "Test your agent";
    }
    return label;
  }

  disable() {
    let isDisabled = false;
    if (this.stepper.selectedIndex == 0) {
      if (!this.agentFirstForm.valid) {
        isDisabled = true;
      }
    }
    if (this.stepper.selectedIndex == 1) {
      if (!this.agentSecondForm.valid) {
        isDisabled = true;
      }
    }
    if (this.stepper.selectedIndex == 2) {
      if (!this.agentThirdForm.valid) {
        isDisabled = true;
      }
    }
    return isDisabled;
  }

  // go To Back Step
  goToBackStep() {
    if (this.stepper.selectedIndex > 0) {
      this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
    }
  }

  // go To Next Step
  goToNextStep() {
    console.log(this.stepper.selectedIndex, this.agentFirstForm)
    if (this.stepper.selectedIndex == 0) {
      console.log(this.agentFirstForm)
      if (this.agentFirstForm.valid) {
        this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
        return;
      }
    }
    if (this.stepper.selectedIndex == 1) {
      console.log(this.agentSecondForm)
      if (this.agentSecondForm.valid) {
        this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
        return;
      }
    }
    if (this.stepper.selectedIndex == 2) {
      console.log(this.agentThirdForm)
      if (this.agentThirdForm.valid) {
        this.saveAgent();
      }
    }
  }

  saveAgent() {
    console.log(this.agentFirstForm.value, this.agentSecondForm.value, this.agentThirdForm.value);
    const combinedObject = Object.assign(
      {},
      this.agentFirstForm.value,
      this.agentSecondForm.value,
      this.agentThirdForm.value
    );

    console.log(combinedObject);

    this.openTestCallAgentPopup();
  }

  openTestCallAgentPopup() {
    const dialogRef = this.dialog.open(TestCallAgentComponent, {
      width: '900px',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  // add more for links
  addMoreLinks() {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.push(this.getOutComesArray());
  }

  // delete Link
  deleteLink(index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.removeAt(index);
  }

  // add more condition
  addMoreConditions(outcomeIndex: number) {
    if (outcomeIndex === undefined || outcomeIndex === null) {
      console.error('Outcome index is undefined or null');
      return;
    }

    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;

    if (!outcomes || outcomes.length <= outcomeIndex) {
      console.error(`Outcomes FormArray is not defined or Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const selectedOutcome = outcomes.at(outcomeIndex);

    if (!selectedOutcome) {
      console.error(`Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const conditions = selectedOutcome.get('conditions') as FormArray;

    if (!conditions) {
      console.error('Conditions FormArray is not defined in the selected outcome');
      return;
    }

    conditions.push(this.getConditionsArray());
  }

  // delete Condition
  deleteCondition(parentIndex, index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    const selectedOutcome = outcomes.at(parentIndex);
    const conditions = selectedOutcome.get('conditions') as FormArray;
    conditions.removeAt(index);
  }

  // add more call action
  addMoreActions(outcomeIndex) {
    if (outcomeIndex === undefined || outcomeIndex === null) {
      console.error('Outcome index is undefined or null');
      return;
    }

    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;

    if (!outcomes || outcomes.length <= outcomeIndex) {
      console.error(`Outcomes FormArray is not defined or Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const selectedOutcome = outcomes.at(outcomeIndex);

    if (!selectedOutcome) {
      console.error(`Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const callActions = selectedOutcome.get('callActions') as FormArray;

    if (!callActions) {
      console.error('Conditions FormArray is not defined in the selected outcome');
      return;
    }

    callActions.push(this.getActionsArray());
  }

  // delete call action
  deleteCallAction(parentIndex, index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    const selectedOutcome = outcomes.at(parentIndex);
    const callActions = selectedOutcome.get('callActions') as FormArray;
    callActions.removeAt(index);
  }

  addMoreOutcomes() {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.push(this.getOutComesArray());
  }

  deleteOutcomes() {

  }

  selectCallAction(callAction: any) {
    console.log(callAction)
  }

  selectAppearance(appearance: any) {

  }

  generateTimeSlots(selectedStartTime?: string, selectedEndTime?: string): {
    timeDifference: string; display: string, value: string
  }[] {
    const times: {
      timeDifference: string; display: string, value: string
    }[] = [];

    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hour12 = ('0' + (h % 12 || 12)).slice(-2); // Convert 0 to 12 for 12-hour format
        const hour24 = ('0' + h).slice(-2); // 24-hour format
        const minute = ('0' + m).slice(-2);
        const period = h < 12 ? 'AM' : 'PM';

        const displayFormat = `${hour12}:${minute} ${period}`;
        const valueFormat = `${hour24}:${minute}`;

        times.push({
          display: displayFormat, value: valueFormat,
          timeDifference: ''
        });
      }
    }
    times.forEach(time => {
      // Calculate time difference for each time option
      // ... calculate time difference based on your logic
      time.timeDifference = '';// assign the calculated time difference
    });
    return times;
  }

  calculateTimeDifference(start: string, end: string): string {
    if (!start || !end) {
      return '';
    }

    const startTime = new Date(`2000-01-01T${start}`);
    const endTime = new Date(`2000-01-01T${end}`);
    let difference = (endTime.getTime() - startTime.getTime()) / 1000;

    // Adjust for negative durations
    if (difference < 0) {
      difference += 24 * 60 * 60; // Adding a day in seconds
    }

    const hours = Math.floor(difference / 3600);
    const minutes = Math.floor((difference % 3600) / 60);

    return `(${hours}.${(minutes < 10 ? '0' : '') + minutes} hours)`;
  }

  scriptGenerateWithAI() {

  }

}
